import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowNotification } from "../Common/showNotification";

function useUploadImage() {
  const [fetchWrapper] = useFetch();
  const showNotification = useShowNotification();

  const [uploadedImageId, setUploadedImageId] = useState();
  const [uploadAbortController, setUploadAbortController] = useState(
    new AbortController()
  );

  const uploadImage = useCallback(
    (
      capturedImage,
      timeout_duration,
      setIsLoading,
      setLoadingTip,
      callGetAiImage
    ) => {
      setIsLoading(true);
      setLoadingTip("Uploading Image...");

      let timeout_id = setTimeout(
        () => {
          //Abort summary, energy consumption distribution, and device list's fetch request
          uploadAbortController.abort("");
          // setIsLoading(false);
          //Assign a new abort controller
          setUploadAbortController(new AbortController());
        },
        (timeout_duration * 1000) / 2
      );

      fetchWrapper({
        endpoint_url: "image/uploadImage",
        abort_controller: uploadAbortController,
        params: {
          image_url: capturedImage,
          image_size: { width: 0, height: 0 },
        },
        onSuccess: (fetch_output) => {
          clearTimeout(timeout_id);
          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            setUploadedImageId(data);
            callGetAiImage(data);
          } else {
            setIsLoading(false);
            showNotification({
              message: "Failed to upload image.",
              description: "Please make sure network connection is available",
            });
          }
        },
        onFetchError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to upload image.",
            description: "Please make sure network connection is available",
          });
        },
        onResponseError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to upload image.",
            description: "Please make sure network connection is available",
          });
        },
      });
    },
    [fetchWrapper]
  );

  return { uploadImage, uploadedImageId, setUploadedImageId };
}

export default useUploadImage;
